import { getDynamicSemanticToken } from '../../../DesignSystem';
import { getDefaultZoomUI } from '../../../ThemeProvider';
export function getDynamicThemeToken(theme) {
    // Get dynamic semantic design token,
    // which can automatically switch between light and dark content
    const semantic = getDynamicSemanticToken(theme);
    const { typography, zIndex, shadow } = theme?.zoomUI ?? getDefaultZoomUI();
    return {
        zIndex: zIndex.Dialog,
        background: semantic.fill.default,
        fontFamily: typography.fontFamily,
        // root
        width: '448px',
        padding: '24px',
        margin: '32px',
        borderRadius: '12px',
        backdropColor: semantic.underlay.dark,
        scrollSplitColor: semantic.border.subtle.neutral,
        shadow: shadow.md,
        // title
        title: {
            color: semantic.text.stronger.neutral,
            minHeight: typography.lineHeight.display3,
            paddingBottom: '16px',
            lineHeight: typography.lineHeight.display3,
            fontSize: typography.fontSize.display3,
            fontWeight: typography.fontWeight.display3,
        },
        // content
        content: {
            color: semantic.text.stronger.neutral,
            minHeight: typography.lineHeight.body,
            lineHeight: typography.lineHeight.body,
            fontSize: typography.fontSize.body,
            fontWeight: typography.fontWeight.body,
        },
    };
}
